import { render, staticRenderFns } from "./entrustOrder.vue?vue&type=template&id=1960a6ca&scoped=true"
import script from "./entrustOrder.vue?vue&type=script&lang=js"
export * from "./entrustOrder.vue?vue&type=script&lang=js"
import style0 from "./entrustOrder.vue?vue&type=style&index=0&id=1960a6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960a6ca",
  null
  
)

export default component.exports